import { render } from "./Logo.vue?vue&type=template&id=0ca9e010&scoped=true"
import script from "./Logo.vue?vue&type=script&lang=js"
export * from "./Logo.vue?vue&type=script&lang=js"

import "./Logo.vue?vue&type=style&index=0&id=0ca9e010&lang=scss&scoped=true"

import exportComponent from "E:\\work\\me\\mayun\\lxk_admin_manage\\node_modules\\.pnpm\\vue-loader@16.8.3_@vue+comp_eee4889a858be1e5640b6fb3f8529091\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ca9e010"]])

export default __exports__